import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import UserImg from "../../assets/images/providerProfileImg.png";
import { useNavigate } from "react-router-dom";
import {
  capitalizeFirstLetter,
  convertDateFormat,
  fetchImage,
  getCurrentISODateTime,
  getFullName,
  twoDecimalPlaces,
} from "../../utils/common";
import { setJobId, setLoader } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../../environment";
import StarRating from "../../components/rating/StarRating";
import {
  toast_error,
  toast_success,
  toast_warning,
} from "../../config/Constant";
import { toast } from "react-toastify";
import socket from "../../socket/socket";
import { selectUser } from "../../slice/authSlice";
import {
  getJobQuoteStatusById,
  updateDeliveryStatus,
  updateProviderStartJob,
} from "../../services/auth.service";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
import ConfirmModal from "../../modals/confirmModal/ConfirmModal";
import StartSelfieModal from "../../modals/startSelfie/StartSelfieModal";
const JobBox = ({
  type,
  job,
  handleMarkComplete,
  handleStartJob,
  handleDispute,
  handleReview,
  acceptAndShare,
  handleInvoice,
  handlePageRefresh,
  rejectJobRequest,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [profilePicURL, setProfilePicURL] = useState(UserImg); // Default image
  const [selectedStatus, setSelectedStatus] = useState("");
  const [confirmStatus, setConfirmStatus] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [startSelfieModal, setStartSelfieModal] = useState(false);

  // const getPrice = () => {
  //   if (!job?.durationExpected) {
  //     return `$${twoDecimalPlaces(job?.unitPrice)}/hour`;
  //   } else {
  //     return `$${twoDecimalPlaces(job?.finalPrice)}`;
  //   }
  // };

  const getPrice = () => {
    const price =
      job?.finalPriceAfterDiscount ??
      job?.finalPrice ??
      job?.unitPrice;

    const isFixed = job?.fixedPrice;

    if (isFixed) {
      return `$${twoDecimalPlaces(price)}`;
    }

    return `$${twoDecimalPlaces(price)}/hour`;
  };

  const handleView = (id) => {
    if (id) {
      dispatch(setJobId(id));
      navigate("/job/detail");
    }
  };

  const handleReshare = (id) => {
    if (id) {
      dispatch(setJobId(id));
      navigate("/job/share-requote");
    }
  };

  const handleFinalEstimate = (id) => {
    if (id) {
      dispatch(setJobId(id));
      navigate("/job/share-finalquote");
    }
  };

  const handleUpdateStatus = (id) => {
    if (id) {
      dispatch(setJobId(id));
      navigate("/job/delivery-status");
    }
  };

  useEffect(() => {
    const fetchProfileImage = async () => {
      if (job?.userId?.profilePic) {
        try {
          const fetchedUrl = await fetchImage(job.userId.profilePic);
          setProfilePicURL(fetchedUrl); // ✅ Update state with fetched image
        } catch (error) {
          setProfilePicURL(UserImg); // Fallback to default image on error
        }
      }
    };

    fetchProfileImage();
  }, [job?.userId?.profilePic]);

  const handleCheckEndSelfie = (job) => {
    handleMarkComplete(job?._id, job);
  };

  const handleChatNow = (job) => {
    const userID = job.userId._id;
    const loggedinuserId = user?.id;
    socket.emit("create-new-chat", [userID, loggedinuserId]);
    socket.on("new-chat-created", (data) => {
      let chatID = data._id;
      navigate(`/chat`);
    });
  };

  const handleChangeStartTime = (id) => {
    navigate("/job/job-update", { state: id });
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e);

    setConfirmStatus(true);
    if (e === "otw") {
      setConfirmText("You want to change status to On the way");
    } else if (e === "inTransit") {
      setConfirmText("You want to change status to In Transit");
    } else if (e === "delivered") {
      setConfirmText("You want to change status to Delivered");
    } else {
      setConfirmText("");
    }
  };

  const changeStatus = (status, job) => {
    if (status === null) {
      return (
        <Button onClick={() => handleStatusChange("otw")} variant="primary">
          I'm on the way
        </Button>
      );
    } else if (status === "otw") {
      return (
        <Button
          onClick={() => handleStatusChange("inTransit")}
          variant="primary"
        >
          In Transit{" "}
        </Button>
      );
    } else if (status === "inTransit") {
      return (
        <Button
          onClick={() => handleStatusChange("delivered")}
          variant="primary"
        >
          Mark as delivered{" "}
        </Button>
      );
    } else {
      return null;
    }
  };

  const handleAddPhotp = (e) => {
    setStartSelfieModal(true);
  };

  const handleConfirm = (status) => {
    if (status) {
      handleSubmit();
    }
    setConfirmStatus(false);
  };

  const handleStartSelfieClose = () => {
    setStartSelfieModal(false);
  };

  const handleSubmit = async (e) => {
    await updateStatus();
  };

  const updateStatus = async (status) => {
    let payload = {
      jobId: job._id,
      [selectedStatus || status]: getCurrentISODateTime(),
    };

    await dispatch(setLoader(true));
    try {
      const response = await updateDeliveryStatus(payload);
      toast.success(response?.data?.message, toast_success);
      handlePageRefresh();

      await dispatch(setLoader(false));
    } catch (error) {
      await dispatch(setLoader(false));
      toast.error(error?.data?.message, toast_error);
    }
  };

  return (
    <div className="job-box">
      <div className="user-info-detail-wrap">
        <div className="user-detail-left">
          <div className="user-pic">
            <img src={profilePicURL} alt="User" />
          </div>
          <div className="user-detail">
            <div className="user-name-wrap">
              {getFullName(job?.userId?.firstName, job?.userId?.lastName)}
            </div>
            <div className="rating-wrap">
              <div className="rating">
                <StarRating size={18} rating={job?.userId?.ratingUser} />
              </div>

              <div className="rating-value">
                {job?.userId?.ratingUser ? (
                  <>({job?.userId?.ratingUser}) </>
                ) : null}
                {job?.userId?.userNumberOfRatings ? (
                  <> - {job?.userId?.userNumberOfRatings} Reviews</>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        {type === "outgoing" && (
          <div className="user-detail-right">
            Request status :{" "}
            <span className={`${job?.requestStatus}`}>
              {capitalizeFirstLetter(job?.requestStatus)}
            </span>
          </div>
        )}

        {type === "cancelled" && (
          <div className="user-detail-right">
            {" "}
            {job?.jobStatus == "REJECTED" ? (
              <span className="cancelled">Rejected</span>
            ) : (
              <span className="cancelled">Cancelled</span>
            )}
          </div>
        )}
      </div>
      {/* {job?.providerTransactionStatus ? (
          <div className="payment-failed">{job?.providerTransactionStatus}</div>
        ) : null} */}
      <div className="job-title-wrap">
        <div className="job-title">
          {job?.serviceId?.name || job?.serviceName}
        </div>
      </div>
      <div className="job-decription">{job?.jobDetail}</div>

      <div className="job-location-detail">
        <tr>
          <Tooltip
            title="If you would like to change the address, please chat with the provider, or cancel this job and book a new one."
            place="top"
          >
            {/* <InfoOutlineIcon style={{ marginLeft: "140px" }} /> */}
          </Tooltip>
        </tr>
        <ul>
          <li>
            {" "}
            <span>Job Type :</span> {capitalizeFirstLetter(job?.jobType)}
          </li>
          <li>
            <span>Date & Time : </span>
            {job?.startTime
              ? convertDateFormat(job?.startTime)
              : convertDateFormat(job?.jobStartTime)}
          </li>

          <li>
            <span>Price :</span> {getPrice(job)}
            {type === "incoming" && (
              <a onClick={() => handleView(job?._id)} href="#">
                View Detail
              </a>
            )}
          </li>
          <li>
            <span>Job Rate :</span>
            {(type === "upcoming" || type === "completed") &&
            job?.fixedPrice > 0
              ? "Fixed"
              : "Hourly"}
          </li>
        </ul>
      </div>
      <div className="job-btn-wrap">
        {type === "upcoming" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => handleChatNow(job)}
            >
              Chat Now
            </Button>
            {job?.jobType === "services" && !job?.providerStartJob && (
              <Button
                variant="outline-primary"
                onClick={() => handleChangeStartTime(job?._id)}
              >
                Change Start Time
              </Button>
            )}
            {job?.providerStartJob === true && job?.jobType === "services" && (
              <Button
                variant="outline-primary"
                onClick={() => handleFinalEstimate(job?._id)}
              >
                Share Final Estimate
              </Button>
            )}

            {(job?.jobType === "moving" || job?.jobType === "delivery") &&
              job?.trackingStatus == "delivered" && (
                <Button
                  variant="outline-primary"
                  onClick={() => handleFinalEstimate(job?._id)}
                >
                  Share Final Estimate
                </Button>
              )}

            {(job?.jobType === "moving" || job?.jobType === "delivery") &&
              job?.providerStartJob &&
              changeStatus(job?.trackingStatus)}
            {(job?.jobType === "moving" || job?.jobType === "delivery") &&
              job?.providerStartJob &&
              job?.trackingStatus !== "delivered" && (
                <Button
                  variant="outline-primary"
                  onClick={() => handleAddPhotp(job?.trackingStatus)}
                >
                  Add Photos
                </Button>
              )}

            {(job?.jobType === "services" ||
              job?.jobType === "moving" ||
              job?.jobType === "delivery") &&
              !job?.providerStartJob && (
                <Button
                  variant="outline-primary"
                  onClick={() => handleStartJob(job)}
                >
                  Start Job
                </Button>
              )}
            {job?.providerStartJob === true && // Check if providerStartJob is exactly true
              (job?.jobType === "services" ||
                ((job?.jobType === "moving" || job?.jobType === "delivery") &&
                  job?.trackingStatus === "delivered")) && (
                <Button
                  variant="outline-primary"
                  onClick={() => handleCheckEndSelfie(job)}
                >
                  Mark job Complete
                </Button>
              )}
          </>
        )}
        {type === "completed" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
            {!job?.isDisputed ? (
              <Button
                variant="outline-primary"
                onClick={() => handleDispute(true, job)}
              >
                Raise Dispute
              </Button>
            ) : null}
            {!job?.ratedByProvider ? (
              <Button
                variant="outline-primary"
                onClick={() => handleReview(job)}
              >
                Share Rating
              </Button>
            ) : null}
            {job?.paymentStatus === "completed" ? (
              <Button
                variant="outline-primary"
                onClick={() => handleInvoice(job)}
              >
                Download Invoice
              </Button>
            ) : null}
          </>
        )}
        {type === "cancelled" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
          </>
        )}
        {type === "past" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
          </>
        )}
        {type === "incoming" && (
          <>
            {/* <Button variant="success" onClick={()=>updateJobRequest(job?._id, 'accepted')}>Accept</Button> */}

            <Button variant="success" onClick={() => acceptAndShare(job?._id)}>
              Revise and Accept Quote
            </Button>
            <Button
              variant="danger"
              onClick={() => rejectJobRequest(job?._id, "rejected", job)}
            >
              Reject
            </Button>
            {/* <Button variant="success"  onClick={()=>acceptAndShare(job?._id)}>Revise Quote Option</Button> */}
            <Button
              variant="outline-primary"
              onClick={() => handleChatNow(job)}
            >
              Chat Now
            </Button>
          </>
        )}
        {type === "outgoing" && (
          <>
            <Button
              variant="outline-primary"
              onClick={() => handleView(job?._id)}
            >
              View Details
            </Button>
            <Button
              variant="outline-primary"
              onClick={() => handleChatNow(job)}
            >
              Chat Now
            </Button>
            {!job?.isQuoteSent ? (
              <Button
                variant="outline-primary"
                onClick={() => handleReshare(job?._id)}
              >
                Reshare Quote
              </Button>
            ) : null}
          </>
        )}
        {confirmStatus ? (
          <ConfirmModal
            isConfirm={confirmStatus}
            text={confirmText}
            handleClose={handleConfirm}
          />
        ) : null}
        {startSelfieModal ? (
          <StartSelfieModal
            startSelfieModal={startSelfieModal}
            handleStartSelfieClose={handleStartSelfieClose}
            details={job}
            setSelectedStatus={setSelectedStatus}
            updateStatus={updateStatus}
          />
        ) : null}
      </div>
    </div>
  );
};

export default JobBox;
